import gql from 'graphql-tag'

export const UPDATE_FAVORITE_LIST_NAME = gql`
  mutation UpdateFavoriteListName($favoriteListName: String!, $updatedFavoriteListName: String!) {
    updateFavoriteListName(
      favoriteListName: $favoriteListName
      updatedFavoriteListName: $updatedFavoriteListName
    ) {
      updatedProductListName
    }
  }
`
